<template>
  <div class="card-condition connection-type" :class="{ noteq: predicate === 'NOT_EQUALS' }">
    <div class="loading-overlay" v-if="loading">
      <loading-circle width="32" height="32" layout="inline" />
      {{ t('Connection type...') }}
    </div>

    <ui-icon
      @click="emit('close')"
      size="12"
      class="card-condition__close"
      v-if="!loading"
      icon="fas fa-times"
    />

    <ui-radio-group
      style-type="inline"
      class="mb-16"
      v-model="predicate"
      v-if="!loading"
      :label="t('Connection type')"
    >
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="EQUALS" :label="t('Equals')" />
        <ui-radio class="ml-16" value="NOT_EQUALS" :label="t('Not equal')" />
      </div>
    </ui-radio-group>

    <div class="type-group" v-if="!loading">
      <ui-checkbox
        v-for="(item, index) in data"
        :key="index"
        :value="item"
        v-model="selected[index]"
        class="mr-16"
        :label="item"
        :true-value="item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingCircle from '@/components/loading-circle.vue';
import { useFlowDictionaryCheckboxCondition } from './useFlowDictionaryCheckboxCondition';

const props = defineProps<{
  target?: unknown;
  conditions: Record<string, { predicate: string; values: string[] }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, loading, data, selected, predicate } = useFlowDictionaryCheckboxCondition(
  props.conditions,
  {
    conditionKey: 'connectType',
    dictionaryKey: 'connection-types',
    initialLoading: true,
  },
);
</script>

<style lang="scss" scoped>
.type-group {
  display: flex;
  flex-wrap: wrap;
}
</style>
